<template>

  <div class="kpjdBox" >
    <div class="kpbanner">
      <div class="kpbCon">
        <div class="conleft">
          <div class="leftTitle">{{result.columnTitle}}</div>
          <div class = 'leftCon'>{{result.columnDesc}}</div>
          <div class="leftBtn" @click = 'handleClickmore'>更多科普知识</div>
        </div>
        <div class="conRight"  @click = 'handleclickdetails(result.platfInfoId)' >
          <img v-if="result.pictureUrl" class="Rightimg" :src="commonUrl+result.pictureUrl" alt="">
          <div v-else class="Rightimg"></div>

          <div class = 'imginclude'>{{ result.title }} </div>
        </div>
      </div>
    </div>

    <div class="kpListBox">
        <div class="listTitle">{{ columnName }}</div>
        <div class = 'seeMoreBox'>
          <div class="seeMore" @click = 'handleclickall'><p>查看全部{{ columnName }}</p><img style = "width:10px;height:10px;margin-left:5px " src="../../../../static/images/kpMore.svg" alt=""></div>
        </div>
        
        <div class="showbox">
          <div class="showLeft">
              <div class = 'xhLsft' :class= "flag == index? 'isxhLsft' : 'xhLsft'  " v-for = '(item,index) in list' :key = 'index'  @click = 'handleClickNav(index,item.id,item.columnName)' @mouseover="mouseover(index,item.id,item.columnName)">
                <div>{{ item.columnName }} <i class="el-icon-arrow-right"></i></div>
              </div>
          </div>

          <div class="showRight">

            <div class = 'xhlist' v-for = '(item,index) in listData' :key = 'index' @click = "handleclickdetails(item.id)">
              <img  class = 'xhimg' v-if= 'item.pictureUrl' :src="commonUrl+item.pictureUrl" alt="">
              <div class="widBox" v-else>
                  <li class="number">{{ item.createDate.slice(8,10) }}</li>
                  <li class="date">{{ item.createDate.slice(0,7)}}</li>
              </div>
             
              <div class = 'xhInfo'>
                <div class="xhtitle">
                  <div class="titlewrite">{{item.title }}</div>
                  <div class="titletime">{{item.createDate.slice(0,10) }}</div>
                </div>
                <div class="contertbox">{{item.digest}}</div>
                <div class="contentbottom">
                  <div class = 'seebox'><img v-if= 'item.clickCount' class = 'liulanimg' src="../../../../static/images/liulan.svg" alt="">{{ item.clickCount }}</div>
                  <div class = 'fenleibox' v-if = 'item.arr'>
                    <div class = 'fenleiItem' v-for = '(v,i) in item.arr' :key= 'i' @click.stop = 'handleclickfenlei(v.id,v.label)'>{{ v.label }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="showBox">

          <div class="showList state" v-for = '(item,index) in listData' :key = 'index' @click = "handleclickdetails(item.id)">
            <div class="showleft">
              <img v-if= 'item.pictureUrl' :src="commonUrl+item.pictureUrl" alt="">
              <div class="widBox" v-else>
                  <li class="number">{{ item.createDate.slice(8,10) }}</li>
                  <li class="date">{{ item.createDate.slice(0,7)}}</li>
              </div>
              </div>
            <div class="showRight">
              <div class="srTitle srstate">
                {{item.title }} 
              </div>
              <div class="srCont" >{{item.digest}}</div>
              <div class="srData">{{ item.createDate.slice(0,10) }}</div>
            </div>
          </div>

        </div> -->
    </div>
  </div>


</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
mounted() {
 this.getlNavInfo()
 this.commonUrl =commonUrl;
 this.getTitleInfo()
 this.getkpjdTitle()
},
data () {
  return {
    swiperOptions1: {
        loop: false,
        loopedSlides: 1,
        slidesPerView: 'auto',
        speed: 500,
        autoplay: {
          delay: 9000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next1",
          prevEl: ".swiper-button-prev1",
        }
      },
    commonUrl:'',
    flag:'0',
    list:[],
    listData:[],
    columnName:'',
    pageInfo:{
      pageSize:3,
      pageNo:1
    },
    platfColumnId:'',
    result:{}
  }
},
methods: {
  handleClickmore(){
    this.$router.push({path:'psCommunication'})
  },
  getkpjdTitle(){
    this.Axios({
      method:"post",
      url:Action.FLOORINDEX_GETFOORINDEXSHOWSCIENCE,
      data:{
        
      }
    }).then(res =>{
        if(res.data.code === '000'){
          this.result = res.data.result
        }else{
            this.$alert(res.data.msg || '系统错误...','错误提示',{
                cofirmButtonText:'确定',
                type:'error'
            })
        }
    }).catch(err =>{
            console.log(err)
    })
  },
  getNewArr(keyArr, valueArr) {
      const arr = []
      keyArr.map((v, i) => {
        const obj = {}
        obj.id = keyArr[i]
        obj.label = valueArr[i]
        arr.push(obj)
      })
      return arr
    },
  getTitleInfo(){
      this.Axios({
          url: Action.FLOORINDEX_GETFLOORINDEXSHOWOTHER,
          method: "post",
          data: {
            sort:'7'
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {//成功发送
            this.columnTitle = data.result.columnTitle
            this.columnDesc = data.result.columnDesc
          } 
          else {
            this.$message({
                showClose: true,
                message: '验证码发送失败',
                type: 'error'
            });
          }
          
      }).catch(function (response) {
          console.log(response);
      });
      
    },
  handleClickNav(index,id,columnName){
    this.flag = index;
    this.platfColumnId = id;
    this.columnName = columnName
      this.gettableInfo()
  },
  mouseover(index,id,columnName){
    this.flag = index;
    this.platfColumnId = id;
    this.columnName = columnName
      this.gettableInfo()
  },
  handleclickfenlei(id,name){
    this.$router.push({
      path:'psCommunicationseach',
      query:{
        id:id,
        name:name
      }
    })
  },
  handleclickall(){
    this.$router.push({
      path:'psCommunication',
      query:{
        platfColumnId:this.platfColumnId
      }
    })
  },
  handleclickdetails(id){
    window.open(`${rootDomain}/psCommunicationdetails?id=${id}`)
    // this.$router.push({
    //   path:'psCommunicationdetails',
    //   query:{
    //     id:id
    //   }
    // })
  },
  getlNavInfo(){
      this.Axios({
        method:"post",
        url:Action.PLATF_PORTALCOLUMNLIST,
        data:{
          columnType:'0',
          isShow:"0",
          "isShowSub" : "4"
        }
      }).then(res =>{
          if(res.data.code === '000'){
            this.list = res.data.result;
            this.list.map((item,index) =>{
              if(item.beeCount == 0 ){
                this.list.splice(index,1)
              }
            })
            this.platfColumnId = this.list[0].id;
            this.columnName = this.list[0].columnName
            this.gettableInfo()
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },

    gettableInfo(){
      this.Axios({
        method:"post",
        url:Action.PROTAL_PLATF_PORTALPAGE,
        data:{
          columnType:'0',
          platfColumnId:this.platfColumnId,
          enableFlag:'0',
          pageInfo:this.pageInfo,
          isShow:'0',//展示到首页
          isShowSub:"4",
        }
      }).then(res =>{
          if(res.data.code === '000'){
            this.listData = res.data.result.list;
            this.listData.map((item,index) =>{
              if(item.productClassNames){
                item.productClassNames=  item.productClassNames.split(',')
                item.productClassIds= item.productClassIds.split(',')
                item.arr = this.getNewArr( item.productClassIds,item.productClassNames)
              }
            })
            console.log(this.listData,111)
            // this.listData.map((item,index)=>{
            //   if(item.digest.length>45){
            //     item.digest = item.digest.slice(0,45) + '...'
            //   }
            // })
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
          console.log(err)
      })
    },

},

}
</script>


<style lang="less" scoped>

.kpjdBox{
  width:100%;
  .kpbanner{
    height: 234px;
	  background: #2c6eff;
    .kpbCon{
      width:1180px;
      height: 234px;
      margin:0 auto;
      display: flex;
      justify-content: space-between; 
      .conleft{
        width:795px;
        height:234px;
        .leftTitle{
          width: 300px;
          height: 50px;
          font-size: 36px;
          color: #ffffff;
          margin:43px 0 5px;
        }
        .leftCon{
          width: 795px;
          height: 56px;
          line-height:28px;
          font-size: 20px;
          color: #ffffff;
        }
        .leftBtn{
          width: 104px;
          height: 34px;
          text-align: center;
          line-height:34px;
          background-color: #ff964a;
          font-size: 14px;
          color: #ffffff;
          margin-top:20px;
          cursor: pointer;
        }
      }
      .conRight{
        width: 339px;
        height: 234px;
        background:#1b52ca;
        display: flex;
        flex-direction: column;
        align-items: center;
        .Rightimg{
          width: 145px;
          height: 145px;
          background-color: #ffffff;
          border-radius: 79px;
          border: solid 4px #ffffff;
          margin-top:32px;
        }
        .imginclude{
          width: 339px;
          padding: 0 20px;
          height: 20px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
          text-align: center;
          margin-top:10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;

        }
      }
    }
  }
  .kpListBox{
    width:1180px;
    margin: 0 auto;
    padding-top:50px;
    .listTitle{
      margin: 0 auto 5px;
      height: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #222222;
      font-weight:900;
      text-align:center;
    }
    .seeMoreBox{
      margin: 0 auto 30px;
      display: flex;
      justify-content: space-around;
      cursor: pointer;
    }
    .seeMore{
      font-size: 14px;
      color:#ff964a;
      display: flex;
      align-items: center;
    }
    .navListBox{
      width:1100px;
      height:66px;
      margin: 0 auto;
      border-bottom: solid 1px #dbdbdb;
      display: flex;
      // padding: 0 50px;
      box-sizing: border-box;
      margin-bottom:30px;
      overflow: hidden;
      .swiper-slide {
        width: auto!important;
      }
      .navItemTitle{
        height:66px;
        font-size: 16px;
	      color: #222222;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right:50px;
      }
      .isnavItemTitle{
        height:66px;
        font-size: 16px;
	      color: #2c6eff;
        display: flex;
        align-items: center;
        border-bottom:3px solid #2c6eff;
        cursor: pointer;
        margin-right:50px;
      }
    }
    .showbox{
      width: 1180px;
      height: 502px;
      background-color: #ffffff;
      box-shadow: 0px 2px 8px 0px 
        #bcbcbc;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      .showLeft{
        width: 240px;
        height: 502px;
        background:url('../../../../static/images/kpjdbj.png') no-repeat 100% 100%;
        margin-right:30px;
        .xhLsft{
          width: 240px;
          height: 48px;
          padding-left:38px;
          box-sizing: border-box; 
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #222222;
          cursor: pointer;
        }
        .isxhLsft{
          border-left: 4px solid #fa6400;
          width: 240px;
          height: 48px;
          background-color: #ffffff;
          padding-left:34px;
          box-sizing: border-box; 
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #fa6400;
          cursor: pointer;
        }
      }
      // .showLeft :hover.xhLsft{
      //   border-left: 4px solid #fa6400;
      //     width: 240px;
      //     height: 48px;
      //     background-color: #ffffff;
      //     padding-left:34px;
      //     box-sizing: border-box; 
      //     display: flex;
      //     align-items: center;
      //     font-size: 16px;
      //     color: #fa6400;
      //     cursor: pointer;
      // }

      .showRight{
        flex:1;
        height:502px;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        padding: 10px 30px 0 0  ;
        .xhlist{
          width:100%;
          height:159px;
          padding: 20px 0px 20px 0 ;
          box-sizing: border-box;
          border-bottom:1px solid #ebebeb;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .xhimg{
            width: 120px;
            height: 120px;
            background-color: #d8d8d8;
            margin-right:20px;
          }
          .xhInfo{
            flex:1;
            height:120px;
            .xhtitle{
              width: 100%;
              height: 28px;
              font-family: PingFangSC-Medium;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom:15px;
              .titlewrite{
                font-weight:900;
                flex:1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #222222;
                font-size: 20px;
              }
              .titletime{
                width: 73px;
                height: 17px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #818d99;
              }
            }
            .contertbox{
              font-family: PingFangSC-Regular;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #818d99;
              height:48px;
            }
            .contentbottom{
              width:100%;
              height:30px;
              display: flex;
              align-items: center;
              color:#818d99;
              .seebox{
                // width:90px;
                margin-right:20px;
                display: flex;
                align-items: center;
                .liulanimg{
                  width:20px;
                  height:12px;
                  margin-right:3px;
                }
              }
              .fenleibox{
                width:600px;
                overflow: hidden;
                height:14px;
                // text-overflow: ellipsis;
                // white-space: nowrap;
                background:url('../../../../static/images/feilei.svg') no-repeat;
                padding-left:20px;
                .fenleiimg{
                  width:20px;
                  height:14px;
                }
                .fenleiItem{
                  float: left;
                  margin-right:10px;
                  cursor: pointer;
                }
              }
            }
          }
          .widBox{
              width: 120px;
              height: 120px;
              background-color: #fff;
              padding:20px 0 ;
              border:1px solid #2c6eff;
              margin-right:20px;
              
              .number{
                width: 120px;
                font-size: 26px;
                text-align: center;
                margin:10px 0 6px;
                font-weight:900;
                color:#2c6eff;
                margin-top:10px;
                
              }
              .date{
                margin-top:10px;
                width: 120px;
                text-align: center;
                height: 24px;
                font-family: ArialNarrow;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #2c6eff;
              }
          }
             
        }
        // .xhlist:hover {
        //     background-color: #ffffff;
        //     box-shadow: 0px 2px 8px 0px 
        //       #bcbcbc;
        //   }

          .xhlist:hover .srstate{
            color: #ff964a;
          }
          .xhlist:hover .widBox{
            background: #2c6eff;
          }
          .xhlist:hover .widBox .number{
            color: #fff;
          }
          .xhlist:hover .widBox .date{
            color: #fff;
          }
      }
    }
    // .showBox{
    //   height:318px;
    //   width:1180px;
    //   margin: 0 auto;
    //   display: flex;
    //   justify-content: space-between;
    //   flex-wrap: wrap;
    //   .state{
    //     background-color: #ffffff;
    //     box-shadow: 0px 2px 8px 0px 
    //       #efefef;
    //     border-radius: 4px;
    //   }
    //   .showList{
    //     width: 578px;
    //     height: 142px;
    //     padding:20px;
    //     box-sizing: border-box;
    //     display: flex ;
    //     cursor: pointer;
    //     .showleft{
    //       width: 102px;
    //       height: 102px;
    //       background-color: #d8d8d8;
    //       border-radius: 4px;
    //        .widBox{
    //           width: 102px;
    //           height: 102px;
    //           background-color: #fff;
    //           padding:10px 0 ;
    //           border:1px solid #2c6eff;
              
    //           .number{
    //             width: 102px;
    //             font-size: 26px;
    //             text-align: center;
    //             margin:6px 0 6px;
    //             font-weight:900;
    //             color:#2c6eff;
    //             margin-top:10px;
                
    //           }
    //           .date{
    //             margin-top:10px;
    //             width: 102px;
    //             text-align: center;
    //             height: 16px;
    //             font-family: ArialNarrow;
    //             font-size: 14px;
    //             font-weight: normal;
    //             font-stretch: normal;
    //             letter-spacing: 0px;
    //             color: #2c6eff;
    //           }
    //         }
    //     }
    //     .showRight{
    //       flex:1;
    //       height:102px;
    //       margin-left:20px;
    //       display: flex;
    //       flex-direction: column;
    //       justify-content: space-between;
    //       .srstate{
    //         background:url('../../../../static/images/rightjt.svg') no-repeat   100% ;
    //       }
    //       .srTitle{
    //         width:410px;
    //         height: 28px;
    //         line-height:28px;
    //         font-size: 20px;
    //         color: #222222;
    //         font-weight:900;
    //         align-items: center;
    //         padding-right:40px;
    //         overflow: hidden;
    //         text-overflow:ellipsis;
    //         white-space: nowrap;
    //         padding-right:50px;
    //         box-sizing: border-box;

            
    //         .line{
    //           height:20px;
    //           width:2px;
    //           background:#222222;
    //           margin: 0 10px;
    //         }
    //       }
         
    //       .srCont{
    //         width:416px;
    //         height: 40px;
    //         font-family: PingFangSC-Regular;
    //         font-size: 14px;
    //         font-weight: normal;
    //         font-stretch: normal;
    //         letter-spacing: 0px;
    //         color: #818d99;
    //         line-height:20px;
    //         overflow: hidden;
    //       }
    //       .srData{
    //         height: 17px;
    //         font-family: PingFangSC-Regular;
    //         font-size: 12px;
    //         font-weight: normal;
    //         font-stretch: normal;
    //         letter-spacing: 0px;
    //         color: #818d99;
    //       }
    //     }
    //   }
    //   .showList:hover {
    //     background-color: #ffffff;
    //     box-shadow: 0px 2px 8px 0px 
    //       #bcbcbc;
    //   }

    //   .showList:hover .srstate{
    //     color: #ff964a;
    //   }
    //   .showList:hover .widBox{
    //     background: #2c6eff;
    //   }
    //   .showList:hover .widBox .number{
    //     color: #fff;
    //   }
    //   .showList:hover .widBox .date{
    //     color: #fff;
    //   }

      
    // }

  }
}
.kpjdBox li {
    list-style: none !important;
} 



</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/kpjd.vue